import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin, Form, Col, Row } from "antd";
import { SelectField } from "../../../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { updateLaborRate } from "../../../ducks/services";
import SuccessMessage from "../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import ErrorMessage from "../../../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch } from "../../../../../../config/hooks";
import { getLaborRate } from "../../../ducks/actions";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  reviseData: number;
  laborRatesId: string;
}

interface FormValues {
  revise_rate: string;
}

export default function LaborRatesReminder(props: PropsType) {
  const { onClose, reviseData, laborRatesId } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const {
    control,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm<FormValues>();

  useEffect(() => {
    if (reviseData) {
      setValue("revise_rate", reviseData?.toString());
    } else {
      setValue("revise_rate", "0");
    }
  }, [reviseData, setValue]);

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    const payload = {
      reminder: val?.revise_rate ? Number(val?.revise_rate) : 0,
    };

    updateLaborRate(laborRatesId, payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Labor rates updated");
        dispatch(getLaborRate(companyId));
        onClose();
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper view_lhr">
        <div className="modal_header">
          <div className="title">
            <h3>Edit labor rates reminder</h3>
            <p>
              Set how often you want employees in charge to get reminders to
              revise hourly rates.
            </p>
          </div>
        </div>
        <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
          <div className="modal_content">
            <Row gutter={16}>
              <Col span={24}>
                <SelectField
                  fieldName="revise_rate"
                  label="Remind to revise rates"
                  control={control}
                  selectOption={[
                    { label: "Every 3 months", value: "3" },
                    { label: "Every 6 months", value: "6" },
                    { label: "Every 9 months", value: "9" },
                    { label: "Annually", value: "12" },
                    { label: "No reminder", value: "0" },
                  ]}
                  defaultValue="0"
                  iProps={{ placeholder: "Remind to revise rates" }}
                  isRequired
                  rules={{
                    required: "Revise rate is required.",
                  }}
                  validate={errors.revise_rate && "error"}
                  validMessage={
                    errors.revise_rate && errors.revise_rate.message
                  }
                  tooltipTitle="Remind to revise rates"
                />
              </Col>
            </Row>
          </div>

          <div className="modal_footer" style={{ marginTop: 22 }}>
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="mint-btn"
            >
              Save changes
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
}
